import { AddressLike } from "../client/Provider";
import { ckbExplorerBaseURL } from "./CKBNetwork";

export interface BlockExplorer {
  getExplorerURL(
    address: AddressLike,
    display: "address" | "token",
    filterAddress?: AddressLike,
  ): string;
}

export class Etherscan implements BlockExplorer {
  baseURL: string;

  constructor(networkName?: string) {
    this.baseURL = `https://${
      networkName ? networkName.toLowerCase() + "." : ""
    }etherscan.io`;
  }

  getExplorerURL(
    address: AddressLike,
    display: "address" | "token",
    filterAddress?: AddressLike,
  ): string {
    let url = `${this.baseURL}/${display}/${address.toString()}`;
    if (display === "token" && filterAddress) {
      url += `?a=${filterAddress};`;
    }
    return url;
  }
}

export class BlockScout implements BlockExplorer {
  baseURL: string;

  constructor(baseURL: string) {
    this.baseURL = baseURL;
  }

  getExplorerURL(
    address: AddressLike,
    display: "address" | "token",
    filterAddress?: AddressLike,
  ): string {
    switch (display) {
      case "address":
        return `${this.baseURL}/address/${address.toString()}`;
      case "token":
        return `${this.baseURL}/tokens/${address.toString()}`;
    }
  }
}

export class Localhost implements BlockExplorer {
  getExplorerURL(
    address: AddressLike,
    display: "address" | "token",
    filterAddress?: AddressLike,
  ): string {
    return `http://blockexplorer.localhost/${display}/${address}`;
  }
}

export class StellarScout implements BlockExplorer {
  baseURL: string;

  constructor(networkName?: string) {
    this.baseURL = `https://stellar.expert/explorer/${networkName}`;
  }

  getExplorerURL(
    address: AddressLike,
    display: "address" | "token",
    filterAddress?: AddressLike,
  ): string {
    return `${this.baseURL}/contract/${address.toString()}`;
  }
}

export class CKBExplorer implements BlockExplorer {
  baseURL: string;

  constructor() {
    // Was pinned to the testnet explorer, which silently produced links to the
    // wrong chain on any other network.
    this.baseURL = ckbExplorerBaseURL;
  }
  getExplorerURL(
    address: AddressLike,
    display: "address" | "token",
    filterAddress?: AddressLike,
  ): string {
    switch (display) {
      case "address":
        return `${this.baseURL}address/${address.toString()}`;
      case "token":
        return `${this.baseURL}script/${address.toString()}/data1`;
    }
  }
}
